<template>
<div class="container">
    <div class="blue-gradient">
       <div @click="() => { this.$router.push({name: 'Products'}) }" class="sale">
           <svg width="1700" height="2600" viewBox="0 0 1700 2600" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M601.245 321.69H560V306.738H659.505V321.69H618.259V427.037H601.245V321.69Z" fill="white"/>
                <path d="M773.383 400.042C772.56 398.171 770.709 396.963 768.664 396.963H708.098L694.865 427.037H677.164L730.271 309.767C731.106 307.923 732.943 306.738 734.967 306.738H748.656L803.306 427.037H785.261L773.383 400.042ZM766.014 383.214L740.063 324.268L714.113 383.214H766.014Z" fill="white"/>
                <path d="M955.987 427.037L955.815 339.391L912.335 412.43H904.43L860.951 339.906V427.037H844.452V306.738H858.545L908.726 391.291L958.221 306.738H972.313L972.485 427.037H955.987Z" fill="white"/>
                <path d="M1114.9 427.037C1113.22 427.037 1111.64 426.219 1110.68 424.845L1090.25 395.76C1087.78 392.241 1083.64 390.372 1079.35 390.428C1079.12 390.431 1078.91 390.432 1078.71 390.432H1048.97V427.037H1031.79V306.738H1078.71C1094.29 306.738 1106.55 310.462 1115.48 317.909C1124.42 325.356 1128.89 335.61 1128.89 348.671C1128.89 357.951 1126.6 365.857 1122.01 372.387C1117.43 378.918 1110.9 383.672 1102.42 386.651L1130.95 427.037H1114.9ZM1078.19 375.824C1089.07 375.824 1097.38 373.476 1103.11 368.778C1108.84 364.081 1111.7 357.378 1111.7 348.671C1111.7 339.964 1108.84 333.319 1103.11 328.736C1097.38 324.038 1089.07 321.69 1078.19 321.69H1048.97V375.824H1078.19Z" fill="white"/>
                <path d="M658.836 501.662H678.427C683.514 501.662 688.005 502.693 691.901 504.755C695.796 506.771 698.821 509.613 700.975 513.279C703.129 516.899 704.206 521.047 704.206 525.721C704.206 530.396 703.129 534.566 700.975 538.233C698.821 541.853 695.796 544.694 691.901 546.757C688.005 548.773 683.514 549.781 678.427 549.781H658.836V501.662ZM678.152 545.382C682.369 545.382 686.058 544.557 689.22 542.907C692.382 541.211 694.834 538.897 696.575 535.964C698.317 532.985 699.188 529.571 699.188 525.721C699.188 521.872 698.317 518.481 696.575 515.548C694.834 512.569 692.382 510.254 689.22 508.605C686.058 506.909 682.369 506.061 678.152 506.061H663.923V545.382H678.152ZM761.634 536.926H734.824L729.05 549.781H723.757L745.754 501.662H750.772L772.77 549.781H767.408L761.634 536.926ZM759.778 532.802L748.229 506.955L736.68 532.802H759.778ZM804.16 506.061H787.25V501.662H826.158V506.061H809.247V549.781H804.16V506.061ZM884.81 545.382V549.781H850.783V501.662H883.779V506.061H855.87V523.178H880.754V527.509H855.87V545.382H884.81ZM968.653 550.194C963.887 550.194 959.579 549.14 955.729 547.032C951.925 544.923 948.924 542.013 946.724 538.301C944.57 534.543 943.493 530.35 943.493 525.721C943.493 521.093 944.57 516.922 946.724 513.21C948.924 509.452 951.948 506.519 955.798 504.411C959.648 502.303 963.955 501.249 968.722 501.249C972.296 501.249 975.596 501.845 978.62 503.036C981.645 504.228 984.211 505.969 986.32 508.261L983.089 511.492C979.331 507.688 974.588 505.786 968.859 505.786C965.055 505.786 961.595 506.657 958.479 508.398C955.363 510.14 952.911 512.523 951.123 515.548C949.382 518.572 948.511 521.964 948.511 525.721C948.511 529.479 949.382 532.871 951.123 535.895C952.911 538.92 955.363 541.303 958.479 543.044C961.595 544.786 965.055 545.657 968.859 545.657C974.633 545.657 979.377 543.732 983.089 539.882L986.32 543.113C984.211 545.405 981.622 547.169 978.552 548.406C975.527 549.598 972.227 550.194 968.653 550.194ZM1025.8 550.125C1022.32 550.125 1019.18 549.346 1016.38 547.788C1013.59 546.184 1011.39 543.984 1009.78 541.188C1008.18 538.393 1007.38 535.231 1007.38 531.702C1007.38 528.173 1008.18 525.011 1009.78 522.216C1011.39 519.42 1013.59 517.243 1016.38 515.685C1019.18 514.127 1022.32 513.348 1025.8 513.348C1029.28 513.348 1032.42 514.127 1035.22 515.685C1038.01 517.243 1040.19 519.42 1041.75 522.216C1043.35 525.011 1044.15 528.173 1044.15 531.702C1044.15 535.231 1043.35 538.393 1041.75 541.188C1040.19 543.984 1038.01 546.184 1035.22 547.788C1032.42 549.346 1029.28 550.125 1025.8 550.125ZM1025.8 545.794C1028.37 545.794 1030.66 545.221 1032.67 544.076C1034.74 542.884 1036.34 541.211 1037.49 539.057C1038.63 536.904 1039.2 534.452 1039.2 531.702C1039.2 528.952 1038.63 526.501 1037.49 524.347C1036.34 522.193 1034.74 520.543 1032.67 519.397C1030.66 518.206 1028.37 517.61 1025.8 517.61C1023.23 517.61 1020.92 518.206 1018.86 519.397C1016.84 520.543 1015.24 522.193 1014.04 524.347C1012.9 526.501 1012.33 528.952 1012.33 531.702C1012.33 534.452 1012.9 536.904 1014.04 539.057C1015.24 541.211 1016.84 542.884 1018.86 544.076C1020.92 545.221 1023.23 545.794 1025.8 545.794ZM1070.09 550.125C1069.08 550.125 1068.21 549.758 1067.48 549.025C1066.79 548.292 1066.45 547.398 1066.45 546.344C1066.45 545.29 1066.79 544.419 1067.48 543.732C1068.21 542.999 1069.08 542.632 1070.09 542.632C1071.1 542.632 1071.97 542.999 1072.7 543.732C1073.44 544.419 1073.8 545.29 1073.8 546.344C1073.8 547.398 1073.44 548.292 1072.7 549.025C1071.97 549.758 1071.1 550.125 1070.09 550.125Z" fill="white" fill-opacity="0.7"/>
                <path d="M925.509 22.4618L904.438 22.4618L805.993 22.4618L784.922 22.4618C750.172 22.4618 715.436 26.5688 680.978 34.7721C674.539 36.3049 667.727 41.5478 662.038 53.0867C656.353 64.6165 653.059 80.2274 653.059 96.7587C653.059 113.29 656.353 128.901 662.038 140.431C667.727 151.97 674.539 157.212 680.978 158.745L687.704 160.347C717.684 167.484 747.899 171.056 778.122 171.056L805.993 171.056L904.438 171.056L932.309 171.056C962.532 171.056 992.747 167.484 1022.73 160.347L1029.45 158.745C1035.89 157.213 1042.7 151.97 1048.39 140.431C1054.08 128.901 1057.37 113.29 1057.37 96.7587C1057.37 80.2274 1054.08 64.6165 1048.39 53.0868C1042.7 41.5478 1035.89 36.3049 1029.45 34.7721C994.995 26.5688 960.259 22.4618 925.509 22.4618Z" stroke="#C29A5C" stroke-width="44.9237"/>
                <path d="M160.512 1406.8H170.112V1465.65H206.497V1474H160.512V1406.8ZM244.872 1406.8H254.472V1474H244.872V1406.8ZM364.255 1474L364.159 1425.04L339.871 1465.84H335.455L311.167 1425.33V1474H301.951V1406.8H309.823L337.855 1454.03L365.503 1406.8H373.375L373.471 1474H364.255ZM420.999 1406.8H430.599V1474H420.999V1406.8ZM491.421 1415.15H468.381V1406.8H523.965V1415.15H500.925V1474H491.421V1415.15ZM610.549 1465.65V1474H561.781V1406.8H609.205V1415.15H571.381V1435.79H605.077V1443.95H571.381V1465.65H610.549ZM653.454 1406.8H681.774C688.878 1406.8 695.182 1408.21 700.686 1411.02C706.19 1413.84 710.446 1417.81 713.454 1422.93C716.526 1427.98 718.062 1433.81 718.062 1440.4C718.062 1446.99 716.526 1452.85 713.454 1457.97C710.446 1463.02 706.19 1466.96 700.686 1469.78C695.182 1472.59 688.878 1474 681.774 1474H653.454V1406.8ZM681.198 1465.65C686.638 1465.65 691.406 1464.59 695.502 1462.48C699.662 1460.37 702.862 1457.42 705.102 1453.65C707.342 1449.81 708.462 1445.39 708.462 1440.4C708.462 1435.41 707.342 1431.02 705.102 1427.25C702.862 1423.41 699.662 1420.43 695.502 1418.32C691.406 1416.21 686.638 1415.15 681.198 1415.15H663.054V1465.65H681.198ZM826.612 1415.15H803.572V1406.8H859.156V1415.15H836.116V1474H826.612V1415.15ZM896.971 1406.8H906.571V1474H896.971V1406.8ZM1016.35 1474L1016.26 1425.04L991.97 1465.84H987.554L963.266 1425.33V1474H954.05V1406.8H961.922L989.954 1454.03L1017.6 1406.8H1025.47L1025.57 1474H1016.35ZM1121.87 1465.65V1474H1073.1V1406.8H1120.52V1415.15H1082.7V1435.79H1116.39V1443.95H1082.7V1465.65H1121.87ZM1248.25 1474.77C1241.46 1474.77 1235.35 1473.3 1229.91 1470.35C1224.47 1467.34 1220.18 1463.22 1217.05 1457.97C1213.98 1452.72 1212.44 1446.86 1212.44 1440.4C1212.44 1433.94 1213.98 1428.08 1217.05 1422.83C1220.18 1417.58 1224.47 1413.49 1229.91 1410.54C1235.35 1407.54 1241.46 1406.03 1248.25 1406.03C1254.97 1406.03 1261.05 1407.54 1266.49 1410.54C1271.93 1413.49 1276.18 1417.58 1279.26 1422.83C1282.33 1428.02 1283.86 1433.87 1283.86 1440.4C1283.86 1446.93 1282.33 1452.82 1279.26 1458.06C1276.18 1463.25 1271.93 1467.34 1266.49 1470.35C1261.05 1473.3 1254.97 1474.77 1248.25 1474.77ZM1248.25 1466.22C1253.18 1466.22 1257.59 1465.1 1261.5 1462.86C1265.46 1460.62 1268.57 1457.55 1270.81 1453.65C1273.11 1449.68 1274.26 1445.26 1274.26 1440.4C1274.26 1435.54 1273.11 1431.15 1270.81 1427.25C1268.57 1423.28 1265.46 1420.18 1261.5 1417.94C1257.59 1415.7 1253.18 1414.58 1248.25 1414.58C1243.32 1414.58 1238.84 1415.7 1234.81 1417.94C1230.84 1420.18 1227.7 1423.28 1225.4 1427.25C1223.16 1431.15 1222.04 1435.54 1222.04 1440.4C1222.04 1445.26 1223.16 1449.68 1225.4 1453.65C1227.7 1457.55 1230.84 1460.62 1234.81 1462.86C1238.84 1465.1 1243.32 1466.22 1248.25 1466.22ZM1383.69 1406.8V1474H1375.82L1335.5 1423.89V1474H1325.9V1406.8H1333.77L1374.09 1456.91V1406.8H1383.69ZM1431.16 1406.8H1440.76V1465.65H1477.15V1474H1431.16V1406.8ZM1534.22 1450.77V1474H1524.72V1450.58L1498.03 1406.8H1508.3L1529.8 1442.22L1551.4 1406.8H1560.91L1534.22 1450.77Z" fill="url(#paint0_linear_0_1)"/>
                <path d="M160.512 1406.8H170.112V1465.65H206.497V1474H160.512V1406.8ZM244.872 1406.8H254.472V1474H244.872V1406.8ZM364.255 1474L364.159 1425.04L339.871 1465.84H335.455L311.167 1425.33V1474H301.951V1406.8H309.823L337.855 1454.03L365.503 1406.8H373.375L373.471 1474H364.255ZM420.999 1406.8H430.599V1474H420.999V1406.8ZM491.421 1415.15H468.381V1406.8H523.965V1415.15H500.925V1474H491.421V1415.15ZM610.549 1465.65V1474H561.781V1406.8H609.205V1415.15H571.381V1435.79H605.077V1443.95H571.381V1465.65H610.549ZM653.454 1406.8H681.774C688.878 1406.8 695.182 1408.21 700.686 1411.02C706.19 1413.84 710.446 1417.81 713.454 1422.93C716.526 1427.98 718.062 1433.81 718.062 1440.4C718.062 1446.99 716.526 1452.85 713.454 1457.97C710.446 1463.02 706.19 1466.96 700.686 1469.78C695.182 1472.59 688.878 1474 681.774 1474H653.454V1406.8ZM681.198 1465.65C686.638 1465.65 691.406 1464.59 695.502 1462.48C699.662 1460.37 702.862 1457.42 705.102 1453.65C707.342 1449.81 708.462 1445.39 708.462 1440.4C708.462 1435.41 707.342 1431.02 705.102 1427.25C702.862 1423.41 699.662 1420.43 695.502 1418.32C691.406 1416.21 686.638 1415.15 681.198 1415.15H663.054V1465.65H681.198ZM826.612 1415.15H803.572V1406.8H859.156V1415.15H836.116V1474H826.612V1415.15ZM896.971 1406.8H906.571V1474H896.971V1406.8ZM1016.35 1474L1016.26 1425.04L991.97 1465.84H987.554L963.266 1425.33V1474H954.05V1406.8H961.922L989.954 1454.03L1017.6 1406.8H1025.47L1025.57 1474H1016.35ZM1121.87 1465.65V1474H1073.1V1406.8H1120.52V1415.15H1082.7V1435.79H1116.39V1443.95H1082.7V1465.65H1121.87ZM1248.25 1474.77C1241.46 1474.77 1235.35 1473.3 1229.91 1470.35C1224.47 1467.34 1220.18 1463.22 1217.05 1457.97C1213.98 1452.72 1212.44 1446.86 1212.44 1440.4C1212.44 1433.94 1213.98 1428.08 1217.05 1422.83C1220.18 1417.58 1224.47 1413.49 1229.91 1410.54C1235.35 1407.54 1241.46 1406.03 1248.25 1406.03C1254.97 1406.03 1261.05 1407.54 1266.49 1410.54C1271.93 1413.49 1276.18 1417.58 1279.26 1422.83C1282.33 1428.02 1283.86 1433.87 1283.86 1440.4C1283.86 1446.93 1282.33 1452.82 1279.26 1458.06C1276.18 1463.25 1271.93 1467.34 1266.49 1470.35C1261.05 1473.3 1254.97 1474.77 1248.25 1474.77ZM1248.25 1466.22C1253.18 1466.22 1257.59 1465.1 1261.5 1462.86C1265.46 1460.62 1268.57 1457.55 1270.81 1453.65C1273.11 1449.68 1274.26 1445.26 1274.26 1440.4C1274.26 1435.54 1273.11 1431.15 1270.81 1427.25C1268.57 1423.28 1265.46 1420.18 1261.5 1417.94C1257.59 1415.7 1253.18 1414.58 1248.25 1414.58C1243.32 1414.58 1238.84 1415.7 1234.81 1417.94C1230.84 1420.18 1227.7 1423.28 1225.4 1427.25C1223.16 1431.15 1222.04 1435.54 1222.04 1440.4C1222.04 1445.26 1223.16 1449.68 1225.4 1453.65C1227.7 1457.55 1230.84 1460.62 1234.81 1462.86C1238.84 1465.1 1243.32 1466.22 1248.25 1466.22ZM1383.69 1406.8V1474H1375.82L1335.5 1423.89V1474H1325.9V1406.8H1333.77L1374.09 1456.91V1406.8H1383.69ZM1431.16 1406.8H1440.76V1465.65H1477.15V1474H1431.16V1406.8ZM1534.22 1450.77V1474H1524.72V1450.58L1498.03 1406.8H1508.3L1529.8 1442.22L1551.4 1406.8H1560.91L1534.22 1450.77Z" fill="white" fill-opacity="0.2"/>
                <path d="M161.44 1228.82C130.027 1228.82 99.5832 1224.36 70.1091 1215.44C41.0227 1206.52 17.9475 1194.69 0.883525 1179.95L27.0613 1121.2C43.7374 1134.38 64.0979 1145.24 88.1426 1153.77C112.575 1161.92 137.008 1165.99 161.44 1165.99C191.69 1165.99 214.184 1161.14 228.921 1151.45C244.046 1141.75 251.608 1128.95 251.608 1113.05C251.608 1101.42 247.342 1091.92 238.81 1084.55C230.666 1076.79 220.195 1070.78 207.397 1066.52C194.599 1062.25 177.147 1057.4 155.041 1051.97C124.016 1044.6 98.8076 1037.24 79.4167 1029.87C60.4136 1022.5 43.9313 1011.06 29.9699 995.545C16.3963 979.644 9.60943 958.314 9.60943 931.555C9.60943 909.061 15.6206 888.701 27.643 870.473C40.0532 851.858 58.4745 837.121 82.9071 826.262C107.727 815.403 137.977 809.974 173.657 809.974C198.477 809.974 222.909 813.076 246.954 819.281C270.999 825.486 291.747 834.406 309.199 846.041L285.348 904.795C267.509 894.324 248.893 886.374 229.502 880.944C210.111 875.515 191.302 872.8 173.075 872.8C143.213 872.8 120.913 877.842 106.176 887.925C91.8269 898.008 84.6522 911.388 84.6522 928.064C84.6522 939.699 88.7243 949.2 96.8685 956.569C105.401 963.937 116.066 969.755 128.864 974.021C141.662 978.287 159.113 983.134 181.219 988.564C211.469 995.545 236.289 1002.91 255.68 1010.67C275.071 1018.04 291.553 1029.48 305.127 1044.99C319.088 1060.5 326.069 1081.45 326.069 1107.82C326.069 1130.31 319.864 1150.67 307.454 1168.9C295.431 1187.13 277.01 1201.67 252.19 1212.53C227.369 1223.39 197.12 1228.82 161.44 1228.82ZM734.969 1128.76H531.364L491.225 1223H413.274L596.518 815.791H670.979L854.805 1223H775.69L734.969 1128.76ZM709.955 1069.42L633.167 891.415L556.96 1069.42H709.955ZM976.399 815.791H1052.02V1159.01H1264.94V1223H976.399V815.791ZM1699.85 1159.59V1223H1394.45V815.791H1691.71V879.199H1470.07V985.074H1666.7V1047.32H1470.07V1159.59H1699.85Z" fill="white"/>
                <path d="M381.94 1776V2014H364.6V1791.64H306.46V1776H381.94ZM493.303 1875.62C527.983 1875.62 553.143 1881.74 568.783 1893.98C584.423 1905.99 592.243 1923.11 592.243 1945.32C592.243 1958.92 589.07 1971.05 582.723 1981.7C576.603 1992.13 567.31 2000.4 554.843 2006.52C542.377 2012.64 527.077 2015.7 508.943 2015.7C491.717 2015.7 475.51 2012.75 460.323 2006.86C445.363 2000.97 433.69 1993.26 425.303 1983.74L434.143 1970.48C441.623 1979.09 451.937 1986.12 465.083 1991.56C478.457 1997 492.963 1999.72 508.603 1999.72C529.91 1999.72 546.23 1994.85 557.563 1985.1C569.123 1975.35 574.903 1962.32 574.903 1946C574.903 1928.09 568.33 1914.49 555.183 1905.2C542.263 1895.91 520.39 1891.26 489.563 1891.26H441.283L453.863 1776H580.003V1791.64H468.483L459.303 1875.62H493.303ZM658.953 1916.2C645.153 1916.2 633.953 1911 625.353 1900.6C616.953 1890.2 612.753 1876.5 612.753 1859.5C612.753 1842.5 616.953 1828.8 625.353 1818.4C633.953 1808 645.153 1802.8 658.953 1802.8C672.753 1802.8 683.953 1808 692.553 1818.4C701.153 1828.8 705.453 1842.5 705.453 1859.5C705.453 1876.5 701.153 1890.2 692.553 1900.6C683.953 1911 672.753 1916.2 658.953 1916.2ZM787.053 1804H799.953L656.553 2014H643.653L787.053 1804ZM658.953 1906C669.553 1906 678.053 1901.9 684.453 1893.7C690.853 1885.3 694.053 1873.9 694.053 1859.5C694.053 1845.1 690.853 1833.8 684.453 1825.6C678.053 1817.2 669.553 1813 658.953 1813C648.553 1813 640.153 1817.2 633.753 1825.6C627.353 1834 624.153 1845.3 624.153 1859.5C624.153 1873.7 627.353 1885 633.753 1893.4C640.153 1901.8 648.553 1906 658.953 1906ZM784.653 2015.2C770.853 2015.2 759.653 2010 751.053 1999.6C742.453 1989.2 738.153 1975.5 738.153 1958.5C738.153 1941.5 742.453 1927.8 751.053 1917.4C759.653 1907 770.853 1901.8 784.653 1901.8C798.453 1901.8 809.553 1907 817.953 1917.4C826.553 1927.8 830.853 1941.5 830.853 1958.5C830.853 1975.5 826.553 1989.2 817.953 1999.6C809.553 2010 798.453 2015.2 784.653 2015.2ZM784.653 2005C795.053 2005 803.453 2000.8 809.853 1992.4C816.253 1984 819.453 1972.7 819.453 1958.5C819.453 1944.3 816.253 1933 809.853 1924.6C803.453 1916.2 795.053 1912 784.653 1912C774.053 1912 765.553 1916.2 759.153 1924.6C752.753 1932.8 749.553 1944.1 749.553 1958.5C749.553 1972.9 752.753 1984.3 759.153 1992.7C765.553 2000.9 774.053 2005 784.653 2005ZM1061.45 2015.7C1038.11 2015.7 1017.03 2010.49 998.212 2000.06C979.399 1989.41 964.552 1974.9 953.672 1956.54C943.019 1938.18 937.692 1917.67 937.692 1895C937.692 1872.33 943.019 1851.82 953.672 1833.46C964.552 1815.1 979.399 1800.71 998.212 1790.28C1017.03 1779.63 1038.11 1774.3 1061.45 1774.3C1084.8 1774.3 1105.88 1779.51 1124.69 1789.94C1143.51 1800.37 1158.24 1814.76 1168.89 1833.12C1179.77 1851.48 1185.21 1872.11 1185.21 1895C1185.21 1917.89 1179.77 1938.52 1168.89 1956.88C1158.24 1975.24 1143.51 1989.63 1124.69 2000.06C1105.88 2010.49 1084.8 2015.7 1061.45 2015.7ZM1061.45 1999.72C1081.4 1999.72 1099.42 1995.19 1115.51 1986.12C1131.61 1977.05 1144.3 1964.59 1153.59 1948.72C1162.89 1932.63 1167.53 1914.72 1167.53 1895C1167.53 1875.28 1162.89 1857.49 1153.59 1841.62C1144.3 1825.53 1131.61 1812.95 1115.51 1803.88C1099.42 1794.81 1081.4 1790.28 1061.45 1790.28C1041.51 1790.28 1023.37 1794.81 1007.05 1803.88C990.959 1812.95 978.266 1825.53 968.972 1841.62C959.679 1857.49 955.032 1875.28 955.032 1895C955.032 1914.72 959.679 1932.63 968.972 1948.72C978.266 1964.59 990.959 1977.05 1007.05 1986.12C1023.37 1995.19 1041.51 1999.72 1061.45 1999.72ZM1286.5 1774.98C1264.28 1774.98 1253.18 1786.88 1253.18 1810.68V1836.52H1309.96V1851.14H1253.52V2014H1236.52V1851.14H1203.88V1836.52H1236.52V1809.32C1236.52 1794.36 1240.82 1782.46 1249.44 1773.62C1258.05 1764.78 1270.18 1760.36 1285.82 1760.36C1292.62 1760.36 1299.08 1761.38 1305.2 1763.42C1311.54 1765.23 1316.76 1768.07 1320.84 1771.92L1314.04 1784.84C1306.78 1778.27 1297.6 1774.98 1286.5 1774.98ZM1391.26 1774.98C1369.04 1774.98 1357.94 1786.88 1357.94 1810.68V1836.52H1414.72V1851.14H1358.28V2014H1341.28V1851.14H1308.64V1836.52H1341.28V1809.32C1341.28 1794.36 1345.58 1782.46 1354.2 1773.62C1362.81 1764.78 1374.94 1760.36 1390.58 1760.36C1397.38 1760.36 1403.84 1761.38 1409.96 1763.42C1416.3 1765.23 1421.52 1768.07 1425.6 1771.92L1418.8 1784.84C1411.54 1778.27 1402.36 1774.98 1391.26 1774.98Z" fill="white"/>
                <path d="M609.003 2163.26C618.315 2163.26 625.467 2165.66 630.459 2170.46C635.451 2175.16 637.947 2182.12 637.947 2191.34V2239H631.035V2225.61C628.635 2230.02 625.131 2233.48 620.523 2235.98C615.915 2238.38 610.395 2239.58 603.963 2239.58C595.611 2239.58 588.987 2237.61 584.091 2233.67C579.291 2229.74 576.891 2224.55 576.891 2218.12C576.891 2211.88 579.099 2206.84 583.515 2203C588.027 2199.06 595.179 2197.1 604.971 2197.1H630.747V2191.05C630.747 2184.04 628.827 2178.71 624.987 2175.06C621.243 2171.42 615.723 2169.59 608.427 2169.59C603.435 2169.59 598.635 2170.46 594.027 2172.18C589.515 2173.91 585.675 2176.22 582.507 2179.1L578.907 2173.91C582.651 2170.55 587.163 2167.96 592.443 2166.14C597.723 2164.22 603.243 2163.26 609.003 2163.26ZM604.971 2233.67C611.211 2233.67 616.491 2232.23 620.811 2229.35C625.227 2226.47 628.539 2222.3 630.747 2216.82V2202.71H605.115C597.723 2202.71 592.347 2204.06 588.987 2206.74C585.723 2209.43 584.091 2213.13 584.091 2217.83C584.091 2222.73 585.915 2226.62 589.563 2229.5C593.211 2232.28 598.347 2233.67 604.971 2233.67ZM664.732 2132.15H671.932V2239H664.732V2132.15ZM699.399 2132.15H706.599V2239H699.399V2132.15ZM768.17 2163.83H775.37V2239H768.17V2163.83ZM771.77 2145.54C770.138 2145.54 768.746 2145.02 767.594 2143.96C766.442 2142.81 765.866 2141.42 765.866 2139.78C765.866 2138.15 766.442 2136.76 767.594 2135.61C768.746 2134.46 770.138 2133.88 771.77 2133.88C773.402 2133.88 774.794 2134.46 775.946 2135.61C777.098 2136.66 777.674 2138.01 777.674 2139.64C777.674 2141.27 777.098 2142.66 775.946 2143.82C774.794 2144.97 773.402 2145.54 771.77 2145.54ZM840.133 2234.25C838.309 2235.98 836.005 2237.32 833.221 2238.28C830.533 2239.14 827.701 2239.58 824.725 2239.58C818.197 2239.58 813.157 2237.8 809.605 2234.25C806.053 2230.6 804.277 2225.56 804.277 2219.13V2170.02H790.453V2163.83H804.277V2147.42H811.477V2163.83H835.381V2170.02H811.477V2218.41C811.477 2223.3 812.629 2227.05 814.933 2229.64C817.333 2232.14 820.837 2233.38 825.445 2233.38C830.149 2233.38 834.037 2231.99 837.109 2229.21L840.133 2234.25ZM918.164 2203.14H853.508C853.7 2209 855.188 2214.23 857.972 2218.84C860.756 2223.35 864.5 2226.86 869.204 2229.35C874.004 2231.85 879.38 2233.1 885.332 2233.1C890.228 2233.1 894.74 2232.23 898.868 2230.5C903.092 2228.68 906.596 2226.04 909.38 2222.58L913.556 2227.34C910.292 2231.27 906.164 2234.3 901.172 2236.41C896.276 2238.52 890.948 2239.58 885.188 2239.58C877.7 2239.58 871.028 2237.94 865.172 2234.68C859.316 2231.42 854.708 2226.9 851.348 2221.14C848.084 2215.38 846.452 2208.81 846.452 2201.42C846.452 2194.12 847.988 2187.59 851.06 2181.83C854.228 2175.98 858.548 2171.42 864.02 2168.15C869.492 2164.89 875.636 2163.26 882.452 2163.26C889.268 2163.26 895.364 2164.89 900.74 2168.15C906.212 2171.32 910.484 2175.78 913.556 2181.54C916.724 2187.3 918.308 2193.83 918.308 2201.13L918.164 2203.14ZM882.452 2169.59C877.172 2169.59 872.42 2170.79 868.196 2173.19C863.972 2175.5 860.564 2178.81 857.972 2183.13C855.476 2187.35 854.036 2192.15 853.652 2197.53H911.252C910.964 2192.15 909.524 2187.35 906.932 2183.13C904.34 2178.9 900.932 2175.59 896.708 2173.19C892.484 2170.79 887.732 2169.59 882.452 2169.59ZM1031.3 2163.26C1040.61 2163.26 1047.91 2165.99 1053.19 2171.46C1058.57 2176.94 1061.25 2184.81 1061.25 2195.08V2239H1054.05V2195.66C1054.05 2187.21 1051.99 2180.78 1047.86 2176.36C1043.73 2171.94 1037.97 2169.74 1030.58 2169.74C1022.13 2169.74 1015.41 2172.38 1010.42 2177.66C1005.53 2182.94 1003.08 2190.04 1003.08 2198.97V2239H995.878V2195.66C995.878 2187.21 993.814 2180.78 989.686 2176.36C985.558 2171.94 979.798 2169.74 972.406 2169.74C963.958 2169.74 957.238 2172.38 952.246 2177.66C947.35 2182.94 944.902 2190.04 944.902 2198.97V2239H937.702V2163.83H944.614V2179.96C947.11 2174.68 950.806 2170.6 955.702 2167.72C960.694 2164.74 966.598 2163.26 973.414 2163.26C980.23 2163.26 985.99 2164.79 990.694 2167.86C995.494 2170.94 998.902 2175.45 1000.92 2181.4C1003.41 2175.83 1007.3 2171.42 1012.58 2168.15C1017.96 2164.89 1024.2 2163.26 1031.3 2163.26ZM1107.11 2239.58C1101.06 2239.58 1095.3 2238.66 1089.83 2236.84C1084.36 2235.02 1080.09 2232.71 1077.02 2229.93L1080.33 2224.17C1083.4 2226.76 1087.34 2228.92 1092.14 2230.65C1097.03 2232.38 1102.12 2233.24 1107.4 2233.24C1114.98 2233.24 1120.55 2231.99 1124.1 2229.5C1127.75 2227 1129.58 2223.54 1129.58 2219.13C1129.58 2215.96 1128.57 2213.46 1126.55 2211.64C1124.63 2209.82 1122.23 2208.47 1119.35 2207.61C1116.47 2206.74 1112.49 2205.83 1107.4 2204.87C1101.45 2203.82 1096.65 2202.66 1093 2201.42C1089.35 2200.17 1086.23 2198.15 1083.64 2195.37C1081.05 2192.58 1079.75 2188.74 1079.75 2183.85C1079.75 2177.9 1082.2 2173 1087.1 2169.16C1092.09 2165.22 1099.14 2163.26 1108.26 2163.26C1113.06 2163.26 1117.82 2163.93 1122.52 2165.27C1127.22 2166.62 1131.06 2168.39 1134.04 2170.6L1130.73 2176.36C1127.66 2174.15 1124.15 2172.47 1120.22 2171.32C1116.28 2170.17 1112.25 2169.59 1108.12 2169.59C1101.11 2169.59 1095.83 2170.89 1092.28 2173.48C1088.73 2176.07 1086.95 2179.48 1086.95 2183.7C1086.95 2187.06 1087.96 2189.7 1089.98 2191.62C1091.99 2193.45 1094.44 2194.84 1097.32 2195.8C1100.3 2196.66 1104.42 2197.62 1109.7 2198.68C1115.56 2199.74 1120.26 2200.89 1123.82 2202.14C1127.46 2203.29 1130.54 2205.21 1133.03 2207.9C1135.53 2210.58 1136.78 2214.28 1136.78 2218.98C1136.78 2225.22 1134.18 2230.22 1129 2233.96C1123.82 2237.7 1116.52 2239.58 1107.11 2239.58Z" fill="white"/>
                <path d="M310.365 2599.48C301.853 2599.48 295.229 2597.02 290.493 2592.09C285.821 2587.16 283.485 2579.96 283.485 2570.49V2531.8H288.381V2570.3C288.381 2578.55 290.269 2584.73 294.045 2588.82C297.821 2592.92 303.293 2594.97 310.461 2594.97C317.565 2594.97 323.005 2592.92 326.781 2588.82C330.557 2584.73 332.445 2578.55 332.445 2570.3V2531.8H337.341V2570.49C337.341 2579.96 334.973 2587.16 330.237 2592.09C325.501 2597.02 318.877 2599.48 310.365 2599.48ZM375.93 2599.48C371.002 2599.48 366.298 2598.65 361.818 2596.98C357.402 2595.26 353.946 2593.05 351.45 2590.36L353.658 2586.71C356.026 2589.21 359.194 2591.26 363.162 2592.86C367.194 2594.39 371.418 2595.16 375.834 2595.16C382.234 2595.16 387.066 2593.94 390.33 2591.51C393.594 2589.08 395.226 2585.91 395.226 2582.01C395.226 2579 394.362 2576.6 392.634 2574.81C390.906 2573.02 388.762 2571.64 386.202 2570.68C383.642 2569.72 380.186 2568.73 375.834 2567.7C370.906 2566.49 366.938 2565.3 363.93 2564.15C360.986 2563 358.458 2561.24 356.346 2558.87C354.298 2556.44 353.274 2553.21 353.274 2549.18C353.274 2545.91 354.138 2542.94 355.866 2540.25C357.594 2537.5 360.218 2535.32 363.738 2533.72C367.322 2532.12 371.77 2531.32 377.082 2531.32C380.794 2531.32 384.442 2531.86 388.026 2532.95C391.61 2534.04 394.714 2535.51 397.338 2537.37L395.514 2541.3C392.826 2539.45 389.85 2538.04 386.586 2537.08C383.386 2536.12 380.218 2535.64 377.082 2535.64C370.874 2535.64 366.17 2536.89 362.97 2539.38C359.77 2541.88 358.17 2545.11 358.17 2549.08C358.17 2552.09 359.034 2554.49 360.762 2556.28C362.49 2558.07 364.634 2559.45 367.194 2560.41C369.754 2561.37 373.242 2562.39 377.658 2563.48C382.586 2564.7 386.522 2565.88 389.466 2567.03C392.41 2568.18 394.906 2569.94 396.954 2572.31C399.066 2574.62 400.122 2577.75 400.122 2581.72C400.122 2584.98 399.226 2587.96 397.434 2590.65C395.706 2593.34 393.018 2595.48 389.37 2597.08C385.722 2598.68 381.242 2599.48 375.93 2599.48ZM461.214 2594.58V2599H414.846V2531.8H459.774V2536.22H419.742V2562.71H455.55V2567.03H419.742V2594.58H461.214ZM528.297 2599.48C521.705 2599.48 515.753 2598.01 510.441 2595.06C505.193 2592.12 501.033 2588.06 497.961 2582.87C494.953 2577.69 493.449 2571.86 493.449 2565.4C493.449 2558.94 494.953 2553.11 497.961 2547.93C501.033 2542.74 505.193 2538.68 510.441 2535.74C515.753 2532.79 521.705 2531.32 528.297 2531.32C533.161 2531.32 537.641 2532.12 541.737 2533.72C545.833 2535.26 549.321 2537.56 552.201 2540.63L549.129 2543.8C543.753 2538.49 536.873 2535.83 528.489 2535.83C522.857 2535.83 517.737 2537.11 513.129 2539.67C508.521 2542.23 504.905 2545.78 502.281 2550.33C499.657 2554.81 498.345 2559.83 498.345 2565.4C498.345 2570.97 499.657 2576.02 502.281 2580.57C504.905 2585.05 508.521 2588.57 513.129 2591.13C517.737 2593.69 522.857 2594.97 528.489 2594.97C536.809 2594.97 543.689 2592.28 549.129 2586.9L552.201 2590.07C549.321 2593.14 545.801 2595.48 541.641 2597.08C537.545 2598.68 533.097 2599.48 528.297 2599.48ZM593.786 2599.48C587.194 2599.48 581.242 2598.01 575.93 2595.06C570.618 2592.06 566.426 2587.96 563.354 2582.78C560.346 2577.59 558.842 2571.8 558.842 2565.4C558.842 2559 560.346 2553.21 563.354 2548.02C566.426 2542.84 570.618 2538.78 575.93 2535.83C581.242 2532.82 587.194 2531.32 593.786 2531.32C600.378 2531.32 606.33 2532.79 611.642 2535.74C616.954 2538.68 621.114 2542.74 624.122 2547.93C627.194 2553.11 628.73 2558.94 628.73 2565.4C628.73 2571.86 627.194 2577.69 624.122 2582.87C621.114 2588.06 616.954 2592.12 611.642 2595.06C606.33 2598.01 600.378 2599.48 593.786 2599.48ZM593.786 2594.97C599.418 2594.97 604.506 2593.69 609.05 2591.13C613.594 2588.57 617.178 2585.05 619.802 2580.57C622.426 2576.02 623.738 2570.97 623.738 2565.4C623.738 2559.83 622.426 2554.81 619.802 2550.33C617.178 2545.78 613.594 2542.23 609.05 2539.67C604.506 2537.11 599.418 2535.83 593.786 2535.83C588.154 2535.83 583.034 2537.11 578.426 2539.67C573.882 2542.23 570.298 2545.78 567.674 2550.33C565.05 2554.81 563.738 2559.83 563.738 2565.4C563.738 2570.97 565.05 2576.02 567.674 2580.57C570.298 2585.05 573.882 2588.57 578.426 2591.13C583.034 2593.69 588.154 2594.97 593.786 2594.97ZM643.791 2531.8H670.383C677.359 2531.8 683.535 2533.24 688.911 2536.12C694.351 2539 698.575 2543 701.583 2548.12C704.591 2553.18 706.095 2558.94 706.095 2565.4C706.095 2571.86 704.591 2577.66 701.583 2582.78C698.575 2587.83 694.351 2591.8 688.911 2594.68C683.535 2597.56 677.359 2599 670.383 2599H643.791V2531.8ZM669.999 2594.58C676.207 2594.58 681.679 2593.37 686.415 2590.94C691.151 2588.44 694.799 2584.98 697.359 2580.57C699.919 2576.15 701.199 2571.1 701.199 2565.4C701.199 2559.7 699.919 2554.65 697.359 2550.23C694.799 2545.82 691.151 2542.39 686.415 2539.96C681.679 2537.46 676.207 2536.22 669.999 2536.22H648.687V2594.58H669.999ZM767.552 2594.58V2599H721.184V2531.8H766.112V2536.22H726.08V2562.71H761.888V2567.03H726.08V2594.58H767.552ZM780.527 2556.66C779.439 2556.66 778.479 2556.28 777.647 2555.51C776.879 2554.68 776.495 2553.69 776.495 2552.54C776.495 2551.38 776.879 2550.42 777.647 2549.66C778.479 2548.89 779.439 2548.5 780.527 2548.5C781.615 2548.5 782.543 2548.89 783.311 2549.66C784.143 2550.42 784.559 2551.38 784.559 2552.54C784.559 2553.69 784.143 2554.68 783.311 2555.51C782.543 2556.28 781.615 2556.66 780.527 2556.66ZM780.527 2599.38C779.439 2599.38 778.479 2599 777.647 2598.23C776.879 2597.4 776.495 2596.41 776.495 2595.26C776.495 2594.1 776.879 2593.14 777.647 2592.38C778.479 2591.61 779.439 2591.22 780.527 2591.22C781.615 2591.22 782.543 2591.61 783.311 2592.38C784.143 2593.14 784.559 2594.1 784.559 2595.26C784.559 2596.41 784.143 2597.4 783.311 2598.23C782.543 2599 781.615 2599.38 780.527 2599.38ZM888.706 2599L874.21 2578.36C872.418 2578.49 871.01 2578.55 869.986 2578.55H853.378V2599H843.778V2531.8H869.986C878.69 2531.8 885.538 2533.88 890.53 2538.04C895.522 2542.2 898.018 2547.93 898.018 2555.22C898.018 2560.41 896.738 2564.82 894.178 2568.47C891.618 2572.12 887.97 2574.78 883.234 2576.44L899.17 2599H888.706ZM869.698 2570.39C875.778 2570.39 880.418 2569.08 883.618 2566.46C886.818 2563.83 888.418 2560.09 888.418 2555.22C888.418 2550.36 886.818 2546.65 883.618 2544.09C880.418 2541.46 875.778 2540.15 869.698 2540.15H853.378V2570.39H869.698ZM954.424 2582.2H918.712L911.32 2599H901.432L931.864 2531.8H941.368L971.896 2599H961.816L954.424 2582.2ZM951.064 2574.52L936.568 2541.59L922.072 2574.52H951.064ZM1042.3 2599L1042.21 2550.04L1017.92 2590.84H1013.5L989.217 2550.33V2599H980.001V2531.8H987.873L1015.9 2579.03L1043.55 2531.8H1051.42L1051.52 2599H1042.3ZM1112.58 2582.2H1076.87L1069.48 2599H1059.59L1090.02 2531.8H1099.53L1130.06 2599H1119.98L1112.58 2582.2ZM1109.22 2574.52L1094.73 2541.59L1080.23 2574.52H1109.22ZM1138.16 2531.8H1166.48C1173.58 2531.8 1179.89 2533.21 1185.39 2536.02C1190.9 2538.84 1195.15 2542.81 1198.16 2547.93C1201.23 2552.98 1202.77 2558.81 1202.77 2565.4C1202.77 2571.99 1201.23 2577.85 1198.16 2582.97C1195.15 2588.02 1190.9 2591.96 1185.39 2594.78C1179.89 2597.59 1173.58 2599 1166.48 2599H1138.16V2531.8ZM1165.9 2590.65C1171.34 2590.65 1176.11 2589.59 1180.21 2587.48C1184.37 2585.37 1187.57 2582.42 1189.81 2578.65C1192.05 2574.81 1193.17 2570.39 1193.17 2565.4C1193.17 2560.41 1192.05 2556.02 1189.81 2552.25C1187.57 2548.41 1184.37 2545.43 1180.21 2543.32C1176.11 2541.21 1171.34 2540.15 1165.9 2540.15H1147.76V2590.65H1165.9ZM1257.43 2582.2H1221.72L1214.33 2599H1204.44L1234.87 2531.8H1244.38L1274.9 2599H1264.82L1257.43 2582.2ZM1254.07 2574.52L1239.58 2541.59L1225.08 2574.52H1254.07ZM1340.8 2531.8V2599H1332.93L1292.61 2548.89V2599H1283.01V2531.8H1290.88L1331.2 2581.91V2531.8H1340.8ZM1374.35 2531.8V2599H1364.85V2540.15H1349.68V2531.8H1374.35ZM1406.33 2558.58C1415.93 2558.58 1422.97 2560.41 1427.45 2564.06C1432 2567.64 1434.27 2572.57 1434.27 2578.84C1434.27 2582.81 1433.31 2586.39 1431.39 2589.59C1429.53 2592.73 1426.69 2595.22 1422.85 2597.08C1419.07 2598.87 1414.4 2599.77 1408.83 2599.77C1404.09 2599.77 1399.52 2599.06 1395.1 2597.66C1390.69 2596.18 1387.04 2594.17 1384.16 2591.61L1388.57 2584.02C1390.88 2586.2 1393.82 2587.96 1397.41 2589.3C1400.99 2590.58 1404.77 2591.22 1408.73 2591.22C1413.79 2591.22 1417.69 2590.17 1420.45 2588.06C1423.26 2585.88 1424.67 2582.94 1424.67 2579.22C1424.67 2575.19 1423.13 2572.15 1420.06 2570.1C1416.99 2567.99 1411.74 2566.94 1404.32 2566.94H1389.05L1392.61 2531.8H1430.53V2540.15H1400.67L1398.85 2558.58H1406.33Z" fill="white"/>
                <defs>
                <linearGradient id="paint0_linear_0_1" x1="130.132" y1="1492.2" x2="480.618" y2="835.052" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E03B3B"/>
                <stop offset="1" stop-color="#FF6A6A"/>
                </linearGradient>
                </defs>
            </svg>
       </div>
    </div>
    <div id="content" class="content">
        <div class="main-grid">
            <div class="split">
                <div id="goodness">
                    <img :src="'/Assets/main/dates-goodness.jpg'" class="fill-image" alt="">
                    <router-link id="dates-link" to="/products/dates">
                        <div class="buy-button">Shop dates</div>
                    </router-link>
                </div>
                <div id="coffee-ad" class="one">
                    <img class="fill-image" :src="'/Assets/main/coffee-lone.jpg'" alt="">
                    <img class="coffee-text" src="/Assets/main/coffee-text.svg" alt="">
                    <router-link id="coffee-link" to="/products/coffee">
                        <div class="buy-button">Shop coffee</div>
                    </router-link>
                </div>
            </div>
            <div id="bundles" class="full">
                <img id="bundles-image" class="fill-image" :src="'/Assets/main/bundles.png'" alt="">
                <img :src="'/Assets/main/bundles-text.svg'" class="fill-image" alt="">
                <router-link id="coffee-link" to="/products/bundle">
                    <div class="buy-button">Shop bundles</div>
                </router-link>
            </div>            
        </div>
    </div>
</div>
</template>

<script>

export default {
  name: 'Home',
  components: {
    
  },
  mounted()
  {
      document.title = "Tamr Date Co - Premium dates to your door";
  },

  methods: { 
    scrollToContent()
    {
        var elmnt = document.getElementById("content");
        elmnt.scrollIntoView({ behavior: 'smooth'});
    }  
  },

}



</script>



<style scoped>

.sale {
    display: flex;
    margin: auto;
    width: 100%;
    margin-top: 5%;
    object-fit: contain;
}

.sale svg {
    margin: auto;
    width: 65%;
    height: 50vh;
    max-width: 350pt;
    object-fit: contain;
}

.big-logo {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 15%;
    max-width: 100pt;
}



.main-grid
{
    display: flex;
    flex-direction: column;
    padding: 5pt;
    gap: 5pt;
    background: white;
    width: 100%;
    box-sizing: border-box;
}

.fp
{
    display: flex;
    overflow-x: scroll;
    padding-left: 20pt;
    padding-top: 20pt;
    padding-bottom: 40pt;
    box-sizing: border-box;
    height: fit-content;
}

.fp .product
{
    display:flex;
    flex-direction: column;    
    padding: 10pt;
    background: white;
    border-radius: 5pt;
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    transition: all ease-in-out 220ms;
    margin-right: 15pt;
    flex:1;
    max-width: 110pt;
}

.fp .product:focus
{
    transform: scale(0.97);
}

.fp .product .thumb
{
    height: 70pt;
}

.fp .product .info
{
    display: flex;
    flex-direction: column;
    padding: 5pt;
    padding-bottom: 2pt;
    border-radius: 2pt;
    border-top: 1pt solid rgb(238, 238, 238);
}

.fp .product .name
{
    max-width: 80%;
    font-size: 0.8em;
    font-weight: 550;
    flex: 1;
    margin-top: 5pt;
}

.fp .product .price
{
    text-align: right;
    flex: 1;
    margin-top: 5pt;
    font-size: 0.87em;
    font-weight: 600;
}



#bundles
{
    position: relative;
    width: 100%;
    padding: 30pt;
    padding-bottom: 90pt;
    box-sizing: border-box;
    overflow: hidden;
    margin: auto;
}

#how-it-works-banner
{
    position: relative;
    margin-left: 0;
}

#how-it-works-banner img
{
    min-height: 280pt;
    object-fit: cover;
    object-position: left;
    filter: brightness(0.9);
    filter: contrast(1.1);
}

.how-text
{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 15%;
    width: 80%;
    max-width: 450pt;
}

.how-desc
{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 25%;
    width: 75%;
    max-width: 600pt;
    color: white;
    font-size: 3.4em;
    letter-spacing: -0.05em;
    text-align: center;
}

.read-more
{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 15%;
    color: white;
    text-decoration: white underline;
}

.buy-button
{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10%;
    background: rgb(255, 255, 255);
    padding: 12pt;
    padding-top: 13pt;
    padding-bottom: 13pt;
    border-radius: 20pt;
    font-weight: 550;
    color: rgb(37, 35, 35);
    font-size: 0.9em;
    line-height: 1em;
}

#goodness
{
    position: relative;
    filter: saturate(1.1);
}

#coffee-ad
{
    position: relative;
    min-height: 400pt;
}

.coffee-text
{
    position: absolute;
    left: 48%;
    transform: translateX(-48%);
    top: 10%;
    width: 63.5%;
    max-width: 400pt;
    max-height: 300pt;
    display: block;
    color: white;
}


#gift-ad
{
    background: url('/Assets/main/tamr-gift-box.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom right;
    width: 100% !important;
    display: flex;
    flex-direction: column;
    padding: 20pt;
    padding-bottom: 25pt;
    height: 100%;
    box-sizing: border-box;
}


#gift-box
{
    margin: auto;
    width: 50%;
    margin-left: 21%;
    padding-bottom: 20pt;
    margin-top: 12%;
}

#gift-text
{
    margin: auto;
    display: block;
    width: 80%;
}

.fill-image
{
    width: 100%;
    object-fit: cover;
    height: 100%;
    max-height: 550pt;
}

.split
{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 5pt;
    flex: 1;
    justify-content: space-between;
}
.one
{
    flex: 1;
    background: whitesmoke;
    width: 100%;
    min-width: 290pt;
    max-width: 100vw !important;
    min-height: 320pt;
    max-height: 92vh;
    box-sizing: border-box;
}

.full
{
    background: whitesmoke;
}

.container
{
    overflow: hidden !important;
    width: 100%;
    background: #A80D0D;
    margin: auto;
}
.content    
{
    position: relative;
    width: 100%;
    height: fit-content;
    z-index: 3 !important;
    margin: auto;
    margin-top: 70vh;
    background: white;
    max-width: 1100pt;
    margin-bottom: 100pt;
}

#ramadan-blue
{
    position: absolute;
    width: 100%;
    background-image: url('/Assets/main/ramadan-blue-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    height: 105vh;
    z-index: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
    left: 0;
    right: 0;
}

#stars
{
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
    
}

#rk
{
    position: fixed;
    margin-top: 11vh;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    max-width: 400pt;
    z-index: -1;
}

#df
{
    margin: auto;
    background-image: url('/Assets/main/dates-float.png');
    background-size: contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    max-width: 500pt;
    z-index: 2;
    object-fit: contain;

}

.blue-gradient
{
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 50vh;
    margin-bottom: 0;
    padding-bottom: 10pt;
    box-sizing: border-box;
    background: #A80D0D;
    display: flex;
    flex-direction: column;
    z-index: 3;
}


.cta 
{
    margin: auto;
    max-width: 90pt;
    padding-bottom: 30pt;
    cursor: pointer;
    
}

.cta svg
{
    width: 90%;
    max-width: 150pt;
}

.cta svg path {
    opacity: 0.4;
}

 @media only screen and (max-width: 750px) {

    #df
    {
        margin: auto;
        background-image: url('/Assets/main/dates-float-mobile.png');
        background-size: contain;
        background-repeat: no-repeat;
        margin-top: -20pt;
    }

    #ramadan-blue
    {
        width: 100%;
        background-image: url('/Assets/main/ramadan-blue-bg-mobile.png');
        background-repeat: no-repeat;
        background-size: cover;
    }

    #stars
    {
        margin-top: 10%;
        width: 140%;
    }

    .main-grid
    {
        padding: 0;
    }

    .split
    {
        display: flex;
        flex-wrap: wrap;
    }

    .one
    {
        margin-bottom: 0pt;
    }
    .content {
        margin-bottom: 0;
    }

    .sale {
        margin-top: 12%;
    }
 }




</style>

